/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Type_InactiveInputs */

const en_api_error_task_type_inactive = /** @type {(inputs: Api_Error_Task_Type_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity is inactive and can no longer be created.`)
};

const pt_br2_api_error_task_type_inactive = /** @type {(inputs: Api_Error_Task_Type_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade está inativa e não pode mais ser criada.`)
};

/**
* | output |
* | --- |
* | "This activity is inactive and can no longer be created." |
*
* @param {Api_Error_Task_Type_InactiveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_type_inactive = /** @type {((inputs?: Api_Error_Task_Type_InactiveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Type_InactiveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_type_inactive(inputs)
	return pt_br2_api_error_task_type_inactive(inputs)
});